import { useSelector } from 'react-redux';

import SmallGroupedColumns from './SmallGroupedColumns.jsx';

const SmallDroppableTileList = ({
  bucketDate,
  pageNumber = 1,
  pageSize,
  showAllItems = false,
  tilesPerRow: tilesPerRowProp,
}) => {
  const stateTilesPerRow = useSelector(state => state.tilesPerRow);
  const tilesPerRow = tilesPerRowProp || stateTilesPerRow;
  const activeStatus = useSelector(state => state.status.activeStatus);
  const dndContext = useSelector(state => state.dndContext);

  const columnTiles = columnId => {
    const { columns, tiles } = dndContext[activeStatus];
    const column = columns[columnId];

    if (column) {
      const { tilesIds } = column;

      return tilesIds.map(tileId => {
        return tiles[tileId];
      });
    }

    return [];
  };

  const paginatedColumns = tiles => {
    const defaultPageSize = (tilesPerRow || 4) % 2 === 0 ? 16 : 15;
    const currentPageSize = pageSize || defaultPageSize;
    const sliceStartIndex = 0;
    const defaultSliceEndIndex = (pageNumber * currentPageSize) / tiles;
    const sliceEndIndex = showAllItems ? undefined : defaultSliceEndIndex;
    const bucketRegex = new RegExp(bucketDate);
    return dndContext[activeStatus].columnOrder
      .filter(column => (bucketDate ? bucketRegex.test(column) : true))
      .slice(sliceStartIndex, sliceEndIndex);
  };

  const filteredColumns = tiles => {
    const { columns } = dndContext.plan;

    return paginatedColumns(tiles)
      .map(columnId => columns[columnId])
      .filter(column => column);
  };

  return (
    <SmallGroupedColumns
      columns={filteredColumns(tilesPerRow)}
      getTiles={columnTiles}
    />
  );
};

export default SmallDroppableTileList;
